import React from 'react';

export default function Title() {
    return (
        <div className="row">
            <div className="col-12">
                <h2 className="pds-typography-bold appText">
                    Firm Contact Application
                </h2>
            </div>
        </div>
    )
}